import { ObjectSchema } from 'yup';
import Yup from '../../services/common/validation';
import { SummaryConsentFormModel } from './summaryConsentForm.model';

export const summaryConsentFormSchema = (): ObjectSchema<SummaryConsentFormModel> => {
  return Yup.object({
    marketingVWFS: Yup.boolean(),
    emailVWFS: Yup.boolean(),
    mobilePhoneVWFS: Yup.boolean(),
    landlineVWFS: Yup.boolean(),
    postVWFS: Yup.boolean(),
    marketingBP: Yup.boolean(),
    emailBP: Yup.boolean(),
    mobilePhoneBP: Yup.boolean(),
    landlineBP: Yup.boolean(),
    postBP: Yup.boolean(),
  });
};
